import React, { FC } from 'react';
import { Box } from '@mui/material';
import BankIDAuth from '../../components/bankid-auth.component';
import { BankIdOrderType, BankIdStatus } from '../../types';

const Bankid: FC = () => {
  /**
   * Handle collect
   * @note: ugly fix with bankIdInstance and signInBankId to work with the same instance here as inside BankIDAuth
   * @param bankIdInstance useBankId instance
   * @param data
   */
  async function handleCollect(bankIdInstance: any, data: BankIdStatus): Promise<void> {
    if (data.type !== BankIdOrderType.Auth) {
      console.error('Wrong order type')
      return
    }

    const socialSecurityNumber = data?.socialSecurityNumber ?? ''
    if (socialSecurityNumber === '') {
      console.error('socialSecurityNumber is empty')
      return
    }

    const orderRef = data?.orderRef ?? ''
    if (orderRef === '') {
      console.error('orderRef is empty')
      return
    }

    // Try to sign in with BankID
    await bankIdInstance.signInBankId({ variables: { socialSecurityNumber, orderRef } })
  }

  return (
    <Box mt={4} width="100%">
      <BankIDAuth
        orderType={BankIdOrderType.Auth}
        collectCallback={handleCollect}
      />
    </Box>
  );
};

export default Bankid;
